import React, { useState, useEffect } from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import MiniLoading from '@components/Gui/MiniLoading';
import { NwButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const StyledIcon = styled(NwIcon)`
    cursor: pointer;
    font-size: ${(props) => (props.$pixelSize ? props.$pixelSize + 'px' : '2rem')};
    opacity: 0.4;
    .fa-primary {
        fill: ${(props) => props.theme.TextColor};
        opacity: 0;
    }
    .fa-secondary {
        fill: ${(props) => props.theme.TextColor};
        opacity: 0.5;
    }

    &.todo-icon-done {
        opacity: 1;
        .fa-primary {
            fill: #fff;
            opacity: 1;
        }
        .fa-secondary {
            fill: ${(props) => props.theme.SuccessColor};
            opacity: 1;
        }
    }

    &.todo-icon-half {
        .fa-primary {
            fill: #fff;
            opacity: 1;
        }
        .fa-secondary {
            fill: ${(props) => props.theme.PrimaryDark};
            opacity: 1;
        }
        opacity: 0.5;
    }
`;

const ToDoCheck = ({
    eventId,
    completedValue,
    halfCompletedValue,
    previewMode,
    viewStyle,
    onStatusChanged,
    action,
    size,
}) => {
    const [completed, setCompleted] = useState(completedValue);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        setCompleted(completedValue);
    }, [completedValue]);

    const onChangeFunction = (e) => {
        if (!previewMode) {
            setLoading(true);
            e.stopPropagation();
            const completedValueToSend = completed ? 'false' : 'true';
            Axios.put(`/todos/setStatus/${eventId}/${completedValueToSend}`)
                .then((data) => {
                    setCompleted(!completed);
                    onStatusChanged();
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('error', error);
                    setLoading(false);
                });
        }
    };

    const getClassName = `todo-icon ${completed ? ' todo-icon-done' : halfCompletedValue ? ' todo-icon-half' : ''}`;
    //const iconType = (completed || halfCompletedValue) ? byPrefixAndName.fasds['circle-check'] : byPrefixAndName.fasds['circle'];
    const iconType =
        completed || halfCompletedValue ? byPrefixAndName.fasds['circle-check'] : byPrefixAndName.fasl['circle-check'];
    return viewStyle === 'button' ? (
        <NwButton
            onClick={action || onChangeFunction}
            label={
                isLoading ? (
                    <MiniLoading />
                ) : (
                    <StyledIcon className={getClassName} loading={isLoading ? 1 : 0} icon={iconType} size={size} />
                )
            }
        />
    ) : isLoading ? (
        <MiniLoading />
    ) : (
        <StyledIcon
            className={getClassName}
            onClick={action || onChangeFunction}
            loading={isLoading ? 1 : 0}
            icon={iconType}
            $pixelSize={size}
        />
    );
};
export default ToDoCheck;
